<template>
    <div class="p-20">
        <AdminTable v-if="loaded"
            :headers="[
                { key: 'date', name: 'Name' , format: (val) => val ? Utils.renderTime(val) : 'N/A'},
            ]"
            :subheader="'Available templates for download'"
            :data="files"
            @row-click="selectDate"
            class="table margin-center"
        />
    </div>
</template>

<script setup>
    
    import AdminTable from '@/components/AdminTable.vue'
    import { ref, onMounted, computed } from 'vue';
    import BO_API from '../api/bo_api.js'
    import Utils from '@/utils/index.js';
    import { useRouter } from 'vue-router';

    const loaded = ref(false);
    const files = ref([]);
    const router = useRouter();

    onMounted(async () => {
        const data = await BO_API.getLogsFiles();
        loaded.value = true;
        console.log(data);
        files.value = data.periods.map(file => {
            return {
                date: file,
            }
        })
        files.value.sort((a, b) => new Date(b.date) - new Date(a.date))
        
    })
    function selectDate(row) {
        console.log(row);

        router.push({ name: 'logs_files', params: { date: row.date } });
    }

</script>

<style scoped lang="scss">

</style>